module.exports = __webpack_public_path__ + "static/img/asyg.c250cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/asyg.png
// module id = TO/A
// module chunks = 26